<template>
  <div class="secondary-articles">
    <template v-for="(nid, index) in latestNewsShownMobileSecondary">
      <china-internet-report-entry-slot
        class="homepage-border"
        v-if="nid === 'china-internet-report-widget' && index < showItems"
        :class="{ first:index === 0, last:index === latestNewsShownMobileSecondary.length - 1 }"
        :key="index"
        ></china-internet-report-entry-slot>
      <article-level-nine
        v-gtm-tracker="{ec: 'Homepage', ea: 'Mobile-homepage-bottom-Lv9', el: false}"
        class="homepage-border"
        :key="index"
        :nid="nid"
        :class="{ first:index === 0, last:index === latestNewsShownMobileSecondary.length - 1 }"
        :destinationTid="getNodeQueueTid('abacus_top')"
        :lazyload="index > 0"
        v-else-if="index < showItems"
      ></article-level-nine>
    </template>
    <template v-for="index in showPlaceholder">
      <div class="wrapper article-level-nine homepage-border" v-if="index !== showPlaceholder" :key="index">
        <content-loader
          :height="130"
          :width="310"
          primaryColor="#000000"
          secondaryColor="#000000"
          uniqueKey="home-bobile-upper-below"
          :animate=false
          class="placeholder"
        >
          <rect x="0" y="18" rx="6" ry="6" width="120" height="12" />
          <rect x="0" y="40" rx="7" ry="7" width="200" height="14" />
          <rect x="0" y="60" rx="7" ry="7" width="200" height="14" />
          <rect x="0" y="80" rx="7" ry="7" width="100" height="14" />
          <rect x="230" y="40" rx="0" ry="0" width="80" height="80" />
        </content-loader>
      </div>
      <div class="wrapper article-level-nine homepage-border last" v-else :key="index">
        <content-loader
          :height="130"
          :width="310"
          primaryColor="#000000"
          secondaryColor="#000000"
          uniqueKey="home-bobile-upper-below"
          :animate=false
          class="placeholder"
        >
          <rect x="0" y="18" rx="6" ry="6" width="120" height="12" />
          <rect x="0" y="40" rx="7" ry="7" width="200" height="14" />
          <rect x="0" y="60" rx="7" ry="7" width="200" height="14" />
          <rect x="0" y="80" rx="7" ry="7" width="100" height="14" />
          <rect x="230" y="40" rx="0" ry="0" width="80" height="80" />
        </content-loader>
      </div>
    </template>
  </div>
</template>
<script>
import { getNodeQueueTid } from 'mixins/utilities'
import ArticleLevelNine from 'components/article-levels/Lv9.vue'
import mounted from 'components/mixins/mounted'
import ChinaInternetReportEntrySlot from 'components/widgets/ChinaInternetReportEntrySlot.vue'
import { mapState } from 'vuex'

export default {
  props: ['latestNewsShownMobileSecondary'],
  mixins: [mounted],
  components: {
    ArticleLevelNine,
    ChinaInternetReportEntrySlot,
  },
  computed: {
    ...mapState([
      'viewportIsMobile',
    ]),
    showItems() {
      if (this.mounted && this.viewportIsMobile) {
        return this.latestNewsShownMobileSecondary.length
      }
      return 1
    },
    showPlaceholder() {
      return this.latestNewsShownMobileSecondary.length - this.showItems
    },
  },
  methods: {
    getNodeQueueTid,
  },
}
</script>



// WEBPACK FOOTER //
// components/homepage/HomeViewMobileUpperBelow.vue